import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserClientRoutingModule } from './user-client-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UserClientRoutingModule
  ]
})
export class UserClientModule { }
